import { PricingSectionCardRowProps } from '@/blocks/PricingSection/types';

import PricingSectionCardCell from './PricingSectionCardCell';
import PricingSectionRowPrimaryText from './PricingSectionRowPrimaryText';
import PricingSectionRowSecondaryText from './PricingSectionRowSecondaryText';

export type PricingSectionCardCellProps = PricingSectionCardRowProps & {
  isHeaderCell?: boolean;
  hasBadgeOfHonor?: boolean;
  isHeaderColumn?: boolean;
};

export default function PricingSectionPriceCardCell(
  props: PricingSectionCardCellProps
) {
  const { primaryText, secondaryText, isHeaderCell, hasBadgeOfHonor } = props;

  const isPrimaryTextAHeader = !secondaryText && !!isHeaderCell;
  const shouldShowSecondaryOnHoverOnly =
    !!secondaryText && !!primaryText && !isHeaderCell && !hasBadgeOfHonor;
  const isSecondaryTextStatic = !shouldShowSecondaryOnHoverOnly && !primaryText;

  return (
    <PricingSectionCardCell
      {...props}
      classNames={{
        wrapper:
          isHeaderCell || props.isHeaderColumn
            ? 'justify-start text-left'
            : undefined
      }}
    >
      {primaryText && (
        <PricingSectionRowPrimaryText
          text={primaryText}
          isHeader={isPrimaryTextAHeader}
          isStatic={!shouldShowSecondaryOnHoverOnly}
          shouldCenter={!secondaryText}
          hasBadgeOfHonor={hasBadgeOfHonor}
        />
      )}
      {secondaryText && (
        <PricingSectionRowSecondaryText
          text={secondaryText}
          animateOnHover={shouldShowSecondaryOnHoverOnly}
          isStatic={isSecondaryTextStatic}
          hasBadgeOfHonor={hasBadgeOfHonor}
        />
      )}
    </PricingSectionCardCell>
  );
}
